import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import { Truncated } from './Truncated.js';
import { TruncateContainer } from './Truncate.styles.js';

var Truncate = function Truncate(_ref) {
  var children = _ref.children,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'middle' : _ref$position,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var _useState = useState(!!expanded),
    _useState2 = _slicedToArray(_useState, 2),
    expand = _useState2[0],
    setExpand = _useState2[1];
  var handleClick = function handleClick() {
    setExpand(!expand);
  };
  return React__default.createElement(TruncateContainer, {
    onDoubleClick: handleClick,
    "data-testid": testId
  }, React__default.createElement(Truncated, {
    expanded: expand,
    position: position
  }, children));
};
Truncate.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  position: PropTypes.oneOf(['end', 'middle']),
  testId: PropTypes.string
};

export { Truncate, Truncate as default };
//# sourceMappingURL=Truncate.js.map
